import { useFlags } from "launchdarkly-react-client-sdk";

import { useSpaceContext } from "src/components/spaces/space-context";

/** On only in a workspace with spaces, so a workspace without any never shows the surfaces. */
export function useAudienceTemplateSpaceAccessEnabled(): boolean {
  const flags = useFlags();
  const { isSpacesEnabled } = useSpaceContext();
  return isSpacesEnabled && Boolean(flags.audienceTemplateSpaceAccessEnabled);
}
